import { gql } from '@apollo/client';

export default gql`
  mutation CreateNotificationTypeMutation(
    $notificationType: NotificationTypeInput!
  ) {
    createNotificationType(input: { notificationType: $notificationType }) {
      notificationType {
        id
      }
    }
  }
`;
